import $ from 'jquery';

// babel-polyfill 적용
import "babel-polyfill";
import Vue from "vue";
import VueRouter from "vue-router";
import VueAxios from "vue-axios";
import axios from "axios";
import DashboardPlugin from "./material-dashboard";


// Plugins
import App from "./App.vue";
import Chartist from "chartist";

// router setup
import routes from "./routes/routes";
import session from "@/kuaa/kuaa-sessions";

// added by psk 20200624 - 로그인 관련
import store from "./vuex/store";
import VueCookies from "vue-cookies";

import VueTheMask from 'vue-the-mask';

import PortalVue from 'portal-vue'
Vue.use(PortalVue);

// jquery
//window.$ = window.jQuery = $;

strict: true;
namespce: true;

// plugin setup
Vue.use(VueRouter);
Vue.use(DashboardPlugin);
Vue.use(VueAxios, axios); // added by psk 20200623 - axios 사용
Vue.use(VueCookies);
Vue.use(VueTheMask);

Vue.directive('focus', { 
  // 바인딩 된 엘리먼트가 DOM에 삽입되었을 때... 
  inserted: function (el) { 
    // 엘리먼트에 포커스를 줍니다 
    el.focus();
  }
});
  
// configure router
//  hash모드로 작동 - mode: "history"
const router = new VueRouter({
  mode: "history",
  base: '',      //process.env.VUE_APP_URL,
  routes, // short for routes: routes
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
  linkExactActiveClass: "nav-item active"
});

router.beforeEach((to, from, next) => {
  let title = to.name;
  const keys = Object.keys(to.params);
  if (keys.length) {
    title = `${to.name}: ${to.params[keys[0]]}`;
    if (to.params[keys[1]]) {
      title += ` ${to.params[keys[1]]}`;
    }
  }
  document.title = title;
  next();
});

/*
router.beforeEach((to, from, next) => {
  console.log("to : 라우트 대상 Route 객체로 이동 => " + to);
  console.log("from : 현재 라우트로 오진 전 라우트 => " + from);
  console.log("next() : 훅이 없는 경우 네비게이션 승인");
  console.log("next(false) 현재 네이게이션 중단");
  console.log(
    "next 훅을 해결하기 위해 호출 next('/') 또는 next({ path: '/'}) 다른 위치로 리디렉션. 현재 네비게이션이 중단되고 새 네비게시션 시작"
  );
});
*/

// global library setup
Vue.prototype.$Chartist = Chartist;
Vue.prototype.$axios = axios; // 왜 전역 변수가 안 먹지...

// added by psk 20200624 - 배포에 대한 팁을 출력하지 않음
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: h => h(App),
  router,
  store, // added by psk 20200624 - 로그인 관련
  beforeCreate() {
    // this.$store.dispatch("loginCheck") // getMemeberInfo
  }
}); // el: "#app" 과 같은 역할 => }).$mount('#app')
